import { X, WarningCircle } from "@phosphor-icons/react"
import Modal from "./Modal"

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => (
  <Modal className="max-w-md" isOpen={isOpen} onClose={onClose}>
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
        <WarningCircle className="text-amber-500" size={24} />
        {title}
      </h2>
      <button
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full"
        onClick={onClose}
      >
        <X size={20} />
      </button>
    </div>

    <p className="text-gray-700 mb-6">{message}</p>

    <div className="flex gap-3">
      <button
        className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        type="button"
        onClick={onClose}
      >
        {cancelText}
      </button>
      <button
        className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        type="button"
        onClick={onConfirm}
      >
        {confirmText}
      </button>
    </div>
  </Modal>
)

export default ConfirmationDialog
